import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Camera, HelpCircle, UserCheck } from 'lucide-react';

const navItems = [
  { key: 'checkin', label: 'Check-in', icon: UserCheck, path: (id) => `/wedding/${id}/checkin` },
  { key: 'photos', label: 'Camera', icon: Camera, path: (id) => `/wedding/${id}/photos` },
  { key: 'quiz', label: 'Quiz', icon: HelpCircle, path: (id) => `/wedding/${id}/quiz` },
];

// `dark` matches the nav to a dark-bodied page (the film camera) instead of
// floating a white bar over it. Light remains the default everywhere else.
export default function GuestNav({ weddingId, dark = false }) {
  const location = useLocation();
  const navigate = useNavigate();

  if (!weddingId) return null;

  const shell = dark
    ? 'bg-navy/85 backdrop-blur-xl border-t border-white/10 shadow-[0_-2px_10px_rgba(0,0,0,0.35)]'
    : 'bg-white/80 backdrop-blur-xl border-t border-gold/10 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]';
  const idle = dark ? 'text-white/40 hover:text-white/70' : 'text-charcoal/40 hover:text-charcoal/60';

  return (
    <nav className={`fixed bottom-0 left-0 right-0 z-50 safe-area-bottom ${shell}`} aria-label="Guest navigation">
      <div className="flex items-center justify-around max-w-md mx-auto">
        {navItems.map(({ key, label, icon: Icon, path }) => {
          const isActive = location.pathname.includes(`/${key}`) ||
            (key === 'checkin' && location.pathname.includes('/checkin'));
          return (
            <button
              key={key}
              onClick={() => navigate(path(weddingId))}
              className={`flex flex-col items-center gap-0.5 py-3 px-6 min-h-[56px] min-w-[64px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/50 focus-visible:rounded-xl ${isActive ? 'text-gold' : idle}`}
              aria-label={label}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="w-5 h-5" />
              <span className="font-body text-xs font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
